import NameQuestion from './NameQuestion';

export default NameQuestion;
